import { ApplicationUserIdForOrderEventValidator } from "../validator/application-user-id-for-order-event.validator";
import { FormSpecification } from "../../interface/type/form-specification.type";
import { IdentityConverter } from "../converter/identity.converter";
import { DescriptionEventValidator } from "../validator/description-event.validator";
import { GenerateCreditNoteValidator } from "../validator/generate-credit-note.validator";
import { OrderEventOriginType } from "../../persistence/dto/order-event-origin-type.enum";
import { OrderEventOriginTypeValidator } from "../validator/order-event-origin-type.validator";
import { OrderEventTypeIdValidator } from "../validator/order-event-type-id.validator";
import { OrderIdValidator } from "../validator/order-id.validator";

	/**
	 * @description
	 *  Formulario de creación y visualización de un nota de CyR/NC.
	 */

export const OrderEventForm: FormSpecification = {

	"applicationUserId": {
		crossValidator: false,
		default: undefined,
		validatorFactory: ApplicationUserIdForOrderEventValidator,
		converter: IdentityConverter,
		errors: [
			{ type: "required", message: "Debe indicar para qué usuario se creará la nota." }
		]
	},
	"descriptionEvent": {
		crossValidator: false,
		default: "",
		validatorFactory: DescriptionEventValidator,
		converter: IdentityConverter,
		errors: [
			{ type: "maxlength", message: "La descripción no debe tener más de {{maxlength.requiredLength}} caracteres (tiene {{maxlength.actualLength}})." }
		]
	},
	"generateCreditNote": {
		crossValidator: false,
		default: false,
		validatorFactory: GenerateCreditNoteValidator,
		converter: IdentityConverter,
		errors: [
			{ type: "required", message: "Debe especificar el tipo de nota (CyR o NC)." }
		]
	},
	"orderEventOriginType": {
		crossValidator: false,
		default: OrderEventOriginType.ZoneManager,
		validatorFactory: OrderEventOriginTypeValidator,
		converter: IdentityConverter,
		errors: [
			{ type: "required", message: "Debe especificar el origen de esta nota." }
		]
	},
	"orderEventTypeId": {
		crossValidator: false,
		default: undefined,
		validatorFactory: OrderEventTypeIdValidator,
		converter: IdentityConverter,
		errors: [
			{ type: "required", message: "Debe especificar la causa que dio origen a la nota." }
		]
	},
	"orderId": {
		crossValidator: false,
		default: undefined,
		validatorFactory: OrderIdValidator,
		converter: IdentityConverter,
		errors: [
			{ type: "required", message: "Debe especificar el pedido sobre el cual realizar la nota." }
		]
	}
};
